import { render } from "./DraftReview.vue?vue&type=template&id=1eb7cd85&scoped=true"
import script from "./DraftReview.vue?vue&type=script&lang=js"
export * from "./DraftReview.vue?vue&type=script&lang=js"

import "./DraftReview.vue?vue&type=style&index=0&id=1eb7cd85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb7cd85"]])

export default __exports__